import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'demo-upp-form',
    templateUrl: './demo-upp-form.html',
    styleUrls: ['../demo-common.scss', './demo-upp-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppFormComponent implements OnInit {
    form!: FormGroup;
    sectionFill: 'clear' | 'solid' = 'solid';
    showWarning = true;
    buttonFloat: 'top' | 'bottom' = 'bottom';
    warningLines: 'solid' | 'none' = 'solid';

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl('', [Validators.required]),
            price: new FormControl(''),
            description: new FormControl(''),
        });
    }

    toggleSectionFill() {
        this.sectionFill = this.sectionFill === 'solid' ? 'clear' : 'solid';
        this.change.markForCheck();
    }

    toggleWarning() {
        this.showWarning = !this.showWarning;
        this.change.markForCheck();
    }

    toggleButtonFloat() {
        this.buttonFloat = this.buttonFloat === 'bottom' ? 'top' : 'bottom';
        this.change.markForCheck();
    }

    onPreview() {
        console.log('Preview:', this.form.value);
    }

    onPublish() {
        console.log('Publish:', this.form.value);
    }

    onSave() {
        console.log('Save:', this.form.value);
    }

    onCancel() {
        this.form.reset();
        this.change.markForCheck();
    }
}
